// React
import React from 'react';
import { useTranslation } from 'react-i18next';

// Libs
import { Dropdown } from 'semantic-ui-react';

type SemanticDropdownWrapperComponentProps = {
    options: string[];
    onChange: (option: string) => void;
    selectedOption?: string;
};

export default function SemanticDropdownWrapperComponent(
    props: SemanticDropdownWrapperComponentProps
): React.ReactElement {
    const { t } = useTranslation();

    function onOptionChange(_: React.SyntheticEvent, { value }: { [key: string]: any }) {
        props.onChange(value);
    }

    function getOptions() {
        return [
            ...(props.options?.sort() || []).map((state) => ({
                text: state,
                value: state,
            })),
        ];
    }

    return (
        <Dropdown
            icon="filter"
            value={props.selectedOption}
            clearable
            labeled
            button
            className="icon tiny"
            selection
            placeholder={t('lead.list.tools.all') || 'show all'}
            options={getOptions()}
            onChange={onOptionChange}
        />
    );
}
